import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { mockArticles } from '@/mocks/articles';

export default function LatestNewsSection() {
  const { t } = useTranslation();
  const latest = mockArticles.slice(0, 9);

  return (
    <section id="latest-news" className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100/70">
      <div className="max-w-[1280px] mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            {t('home_latestNews_title1')}
            <br />
            {t('home_latestNews_title2')}
          </h2>
          <p className="text-sm text-foreground-600 mt-2">{t('home_latestNews_subtitle')}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {latest.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group block rounded-2xl border border-background-300/60 bg-background-50 overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3 whitespace-nowrap">
                  {article.categoryName}
                </span>
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span>{article.date}</span>
                  <span>{article.views} 阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="flex justify-center mt-10">
          <Link
            to="/category/star-scandal"
            className="px-6 py-2.5 rounded-full border border-foreground-300 text-foreground-700 text-sm font-medium hover:bg-foreground-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            查看更多瓜料 →
          </Link>
        </div>
      </div>
    </section>
  );
}